import React from 'react';

interface ISelectionsBadge {
  selections: number;
}

const FilterSelectionsBadge: React.FC<ISelectionsBadge> = ({ selections }) => {
  return (
    <div className='selections-badge-container'>
      <div className='selections-badge-num'>
        {selections} Active
      </div>
    </div>
  );
};

export default FilterSelectionsBadge;
